import { SharedOutputEditComponent } from '../../components/SharedInputEdit';
import { useContext } from 'react';
import { CalculatorHtmModeContext } from '../../../../shared/contexts/CalculatorContext';
import { CalculatorHTMMode } from '../../../../shared/classes/CalculatorMode';

export function BreakFixOutput(): JSX.Element {
    const [calculatorModeValue,] = useContext(CalculatorHtmModeContext)!;

    return (
        <div>

            <h2 className='acc-o-badge'>Break and Fix</h2>

            <div className="examinations">

                <SharedOutputEditComponent inputName="break_fix_exams_loss"/>
            </div>

            <div className="operations">

                <SharedOutputEditComponent inputName="operating_hours_lost"/>
                <SharedOutputEditComponent inputName="average_admin_fee_costs_for_rescheduling_exams"/>
            </div>

            <div className="workforce">

                <SharedOutputEditComponent inputName="staff_cost_due_to_iddle_time"/>

                <SharedOutputEditComponent inputName="staff_overtime_cost"/>

            </div>

            <div className="revenue">

                <SharedOutputEditComponent inputName="break_fix_revenue_loss"/>
            </div>

            {
                calculatorModeValue === CalculatorHTMMode.HTM
                    ? <div className="inhouse">

                        <SharedOutputEditComponent inputName="labor_productivity_in_hours"/>

                        <SharedOutputEditComponent inputName="labor_productivity"/>
                    </div>
                    : ''
            }

            <SharedOutputEditComponent inputName="estimated_Loss"/>

        </div>
    );
}
